import styled from 'styled-components';
import {theme} from '@styles/theme';

export const ModalWrapper = styled.div`
  width: 432px;
`;

export const ModalContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  padding: 24px;
  justify-content: center;
  border-top: 1px solid ${theme.colors.basic06};
`;

export const TestCoverageModuleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.basic07};
  border: 1px solid ${theme.colors.basic05};
  border-radius: ${theme.roundedMedium};
`;
